<template>
  <div class="flex flex-col pt-[22px]">
    <div class="text-[#000000] text-[14px] text-left font-bold">
      Últimas comissões recebidas
    </div>
    
    <FilterComponent @filter-applied="handleFilterApplied" />
    
    <div class="grid grid-cols-1 gap-2 mt-2 text-left w-full">
      <div class="grid grid-cols-3 bg-[#F9F4FF] text-[10px] text-[#929292] p-2 rounded">
        <span>Data</span>
        <span>Valor (R$)</span>
        <span>Recebida em</span>
      </div>
      <div v-for="commission in commissions" :key="commission.user_id + commission.received_at" class="grid grid-cols-3 p-2 border-b text-[11px]">
        <div>{{ formatDate(commission.webhook_date) }}</div>
        <div class="font-bold text-green-600">R$ {{ parseFloat(commission.commission).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</div>
        <div>{{ formatDateTime(commission.received_at) }}</div>
      </div>
      <span v-if="commissions.length === 0" class="block w-full h-[150px] bg-gray-300 rounded-md animate-pulse mt-2"></span>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import FilterComponent from './FilterComponent.vue';
import { format } from 'date-fns';

export default {
  name: "CommissionsList",
  props: ['affiliate_id'],
  components: {
    FilterComponent
  },
  data() {
    return {
      commissions: [],
      startDate: null,
      endDate: null
    };
  },
  async created() {
    await this.fetchCommissions();
  },
  watch: {
    affiliate_id: {
      handler() {
        this.fetchCommissions(this.startDate, this.endDate);
      },
      immediate: true
    }
  },
  methods: {
    async fetchCommissions(start_date = null, end_date = null) {
      console.log('Fetching Commissions:', start_date, end_date);
      // Exibir animação de carregamento
      this.commissions = [];
      try {
        const params = {};
        if (start_date && end_date) {
          params.start_date = format(new Date(start_date), 'yyyy-MM-dd');
          params.end_date = format(new Date(end_date), 'yyyy-MM-dd');
        }
        if (this.affiliate_id) {
          params.affiliate_id = this.affiliate_id;
        }
        const response = await api.get('/dashboard/api/commissions/', { params });
        
        console.log('Commissions response:', response);
        this.commissions = response.data;
      } catch (error) {
        console.error('Erro ao obter as comissões:', error);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR');
    },
    formatDateTime(datetime) {
      return new Date(datetime).toLocaleString('pt-BR');
    },
    handleFilterApplied({ start, end }) {
      console.log('Commission Filter Applied:', start, end);
      this.startDate = start;
      this.endDate = end;
      this.fetchCommissions(start, end);
    }
  }
};
</script>

<style scoped>
/* Adicione estilos adicionais aqui, se necessário */
</style>